module.exports = __webpack_public_path__ + "img/productServices-sjmm-icon.9415332a.png";